// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardV1CreateCardDefaultResponse {
    static getAttributeTypeMap() {
        return CardV1CreateCardDefaultResponse.attributeTypeMap;
    }
}
CardV1CreateCardDefaultResponse.discriminator = undefined;
CardV1CreateCardDefaultResponse.additionalProperties = false;
CardV1CreateCardDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ICreateCardResponseModel>"
    },
];
//# sourceMappingURL=cardV1CreateCardDefaultResponse.js.map